import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import fastfood from '../../Assets/Images/HomeCategory/C2.jpg';
import Beverages from '../../Assets/Images/HomeCategory/C1.jpg';
import Meals from '../../Assets/Images/HomeCategory/C3.jpg';
import Snacks from '../../Assets/Images/HomeCategory/C4.jpg';
import Healthy from '../../Assets/Images/HomeCategory/C5.jpg';
import Desserts from '../../Assets/Images/HomeCategory/C6.jpg';


const categories = [
    { id: 1, name: "Fast Food", image: fastfood },
    { id: 2, name: "Beverages", image: Beverages },
    { id: 3, name: "Meals", image: Meals },
    { id: 4, name: "Snacks", image: Snacks },
    { id: 5, name: "Healthy Options", image: Healthy },
    { id: 6, name: "Desserts", image: Desserts },
];

const CategoryCard = ({ category, index }) => {
    return (
        <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            whileHover={{ y: -5 }}
            className="text-center group cursor-pointer"
        >
            <Link to='/restaurants'>
                <div className="mb-4 mx-auto group">
                    {/* Circle container */}
                    <div className="relative w-24 h-24 md:w-32 md:h-32 mx-auto rounded-full overflow-hidden shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                        <img
                            src={category.image}
                            alt={category.name}
                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                        />
                        {/* Red overlay inside circle */}
                        <div className="absolute inset-0 bg-redbg/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>
                </div>
                <p className="text-darktxt group-hover:text-redtxt text-sm md:text-base font-semibold transition-colors duration-300">
                    {category.name}
                </p>
            </Link>
        </motion.div>
    );
};

const HomeCategory = () => {
    return (
        <section className="py-14 md:py-16 px-4 bg-snowbg">
            <div className="container mx-auto max-w-6xl">
                <motion.div
                    initial={{ y: 30, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="text-center mb-12"
                >
                    <h2 className="text-darktxt text-2xl md:text-4xl font-bold mb-4">
                        What's On Your Plate?
                    </h2>
                    <h3 className="text-lightGray text-base md:text-lg font-semibold max-w-2xl mx-auto">
                        Explore the diverse range of delicious food categories
                    </h3>
                </motion.div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 md:gap-12">
                    {categories.map((category, index) => (
                        <CategoryCard key={category.id} category={category} index={index} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeCategory;